import React from 'react';
import moment from 'moment';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

import { compressorTypes, DeviceType, dryerTypes } from '@/constants/deviceTypeEnum';

import { Entity } from '../../NodeWidget.types';
import CompAirAssurePlanIcon from '@/comp/common/icons/CompAirAssurePlanIcon';
import CompAirAssurePlanPlusIcon from '@/comp/common/icons/CompAirAssurePlanPlusIcon';
import CompAirAssureCompleteIcon from '@/comp/common/icons/CompAirAssureCompleteIcon';
import GDPlatinumTrustIcon from '@/comp/common/icons/GDPlatinumTrustIcon';
import GDPlatinumGuardIcon from '@/comp/common/icons/GDPlatinumGuardIcon';
import PartsCareIcon from '@/comp/common/icons/PartsCareIcon';
import PlannedCareIcon from '@/comp/common/icons/PlannedCareIcon';
import PackageCareIcon from '@/comp/common/icons/PackageCareIcon';

const deviceTypesWithPackageCare = [...compressorTypes, ...dryerTypes, DeviceType.Booster];

const deviceModelOrTypeHasPackageCare = (entity: Entity, t: (key: string) => string) => {
  const displayModelType = t(entity.deviceType);

  return entity?.modelDisplayName !== undefined
    ? entity.modelDisplayName?.toLowerCase().includes('dryer') ||
        displayModelType.toLocaleLowerCase().includes('dryer') ||
        entity.modelDisplayName?.toLowerCase().includes('compressor') ||
        displayModelType.toLocaleLowerCase().includes('compressor')
    : false;
};

export const shouldDisplayCareStatus = (currentAsset, entity: Entity, t: (key: string) => string): boolean => {
  if (isEmpty(currentAsset) || isNil(currentAsset.SfsContract)) return false;

  return (
    deviceTypesWithPackageCare.includes(entity.deviceType as DeviceType) || deviceModelOrTypeHasPackageCare(entity, t)
  );
};

export const getFormattedSfsContract = (sfsContract: string): string => {
  return sfsContract?.toLowerCase().replace(/\s/g, '');
};

export const formatEndDate = (endDate: string): string => moment(endDate).format('MM.DD.YYYY');

type IconProps = { [key: string]: unknown };

const careProgramIcons: Record<string, React.FC<IconProps>> = {
  // CompAir
  assureplan: CompAirAssurePlanIcon,
  'assureplan+': CompAirAssurePlanPlusIcon,
  assurecomplete: CompAirAssureCompleteIcon,

  // GD
  platinumtrust: GDPlatinumTrustIcon,
  platinumguard: GDPlatinumGuardIcon,
  platinumguardrenew: GDPlatinumGuardIcon,

  // IR
  partscare: PartsCareIcon,
  packagecare: PackageCareIcon,
  plannedcare: PlannedCareIcon,
};

export const getCareProgramIcon = (sfsContract: string): React.FC<IconProps> => {
  return careProgramIcons[sfsContract] || null;
};
